<template>
    <div>
        <bs-card class="card-info">
            <bs-table v-bind="{dataLength, loading}" :cols="2">
                <template v-slot:thead>
                    <tr v-if="resourceState.search.active">
                        <th class="p-1" colspan="1">
                            <input type="text" class="form-control form-control-sm border-1 border-primary shadow-sm bg-light" v-model="searchPhrase">
                        </th>
                        <th class="text-right"><bs-action :icon="['fas', 'times']" class="btn-outline-secondary" @click="applySearch({active: false, phrase: ''})"></bs-action></th>
                    </tr>
                    <tr v-else>
                        <bs-th :label="$t('labels.name')" :sortable="resourceState.sort" :col="'name'" @click="applySort"></bs-th>
                        <th class="text-right"><bs-action :icon="['fal', 'search']" class="btn-outline-secondary" @click="applySearch({active: true, phrase: ''})"></bs-action></th>
                    </tr>
                </template>
                <tr v-for="r in resources.data" :key="r.id">
                    <td class="clickable" @click="$router.push({ path: '/customer/' + r.id })">{{ r.name }}</td>
                    <td class="t2">
                        <bs-action v-if="auth.can['edit_customers']" :icon="['fal', 'pencil']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.edit') })" class="btn-info" @click="update(r)"></bs-action>
                        <bs-action v-if="auth.can['edit_customers']" :icon="['fal', 'trash']" :tip="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })" class="btn-danger" @click="destroy(r)"></bs-action>
                    </td>
                </tr>
            </bs-table>
        </bs-card>
        <bs-modal :name="'create-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: resource.id ? $t('labels.edit') : $t('labels.create') })">
            <bs-form :submit="$t('labels.submit')" @submit="submit">
                <template v-slot:default="slotProps">
                    <tuxedo-input :name="'name'" :label="$t('labels.name')" v-model="resource.name" :error="slotProps.error"></tuxedo-input>
                </template>
            </bs-form>
        </bs-modal>
        <bs-modal :name="'destroy-' + $options.name" :label="$t('labels.action_' + camelToSnake(singular($options.name)), { action: $t('labels.destroy') })">
            <bs-form :destroy="$t('labels.destroy')" @submit="destruction">
                {{ $t('messages.delete', { resource: $t('labels.customer') }) }}
            </bs-form>
        </bs-modal>
        <portal to="app-footer">
            <pagination :data="resources" :state="resourceState" @pushPage="index"></pagination>
        </portal>
    </div>
</template>

<script>
import { mapState } from 'vuex'
import { debounce } from 'debounce'

export default {
  name: 'Customers',
  data () {
    return {
      loading: false,
      activeId: null,
      resource: {
        name: ''
      }
    }
  },
  mounted () {
    this.search = debounce(this.search, 500)
    this.index(this.resourceState.page)
  },
  computed: {
    ...mapState({
      auth: state => state.auth,
      resources: state => state.customers,
      submitting: state => state.submitting,
      resourceState: state => state.customersState
    }),
    dataLength () {
      let length = 0
      if (this.resources.data) length = this.resources.data.length
      return Math.max(this.resourceState.tableRows - length, 0)
    },
    searchPhrase: {
      get () {
        return this.resourceState.search.phrase
      },
      set (val) {
        this.applySearch({ active: true, phrase: val })
      }
    }

  },
  methods: {
    applySearch (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'search', data: val })
      this.search()
    },
    search () { this.index(1) },
    applySort (val) {
      this.$store.commit('pushState', { view: this.$options.name, key: 'sort', data: val })
      this.index()
    },
    index (page, count) {
      if (page) this.$store.commit('pushState', { view: this.$options.name, key: 'page', data: page })
      if (count) this.$store.commit('pushState', { view: this.$options.name, key: 'tableRows', data: count })
      this.loading = true
      this.$store.dispatch('index', {
        collection: this.$options.name,
        data: {
          icon: ['fal', 'address-book']
        }
      }).then(() => {
        this.loading = false
      })
    },
    create () {
      this.$root.clearData(this.resource)
      this.$modal.show('create-' + this.$options.name)
    },
    destroy (o) {
      this.activeId = o.id
      this.$modal.show('destroy-' + this.$options.name)
    },
    update (o) {
      this.resource = JSON.parse(JSON.stringify(o))
      this.$modal.show('create-' + this.$options.name)
    },
    submit () {
      this.$store.dispatch(this.resource.id ? 'update' : 'store', { collection: this.$options.name, resource: this.resource }).then(() => {
        this.$modal.hide('create-' + this.$options.name)
      })
    },
    destruction () {
      this.$store.dispatch('destroy', { collection: this.$options.name, id: this.activeId }).then(() => {
        this.$modal.hide('destroy-' + this.$options.name)
      })
    }
  }
}
</script>
